export default {
  title: 'user',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Nazwa użytkownika',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Login użytkownika musi być adresem e-mail.'
      }
    },
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: true
        },
        firstName: {
          title: 'Imię użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          computed: true,
          calc: '$root.login'
        },
        mainImage: {
          title: 'Avatar',
          type: 'number'
        }
      }
    }
  }
};
